import {v3ApiClient} from "../clients/v3ApiClient";

export const integrateDriveUser = async (
  userId: string,
  code?: string
) => {
  const response = await v3ApiClient.post(
    `google-general/drive-code/${userId}`,
    { code }
  );

  return response.data;
};

export const getGoogleDriveIntegrationStatus = async (userId: string) => {
  const response = await v3ApiClient.get(
    `google-general/drive-status/${userId}`
  );

  return response.data;
}

